import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import PositionsView from "@/features/K1Dashboard/views/PositionsView";

export default function K1Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <PositionsView />
      </main>
    </K1DashboardProvider>
  );
}
